import validate from "/home/user/aiboosted-website/node_modules/nuxt/dist/pages/runtime/validate.js";
import utm_45logging_45global from "/home/user/aiboosted-website/middleware/utmLogging.global.ts";
import manifest_45route_45rule from "/home/user/aiboosted-website/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  utm_45logging_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/user/aiboosted-website/middleware/auth.ts")
}